import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import { Link,
         LinkIcon } from '../../components'
import Styles from './FooterPartner.css'

@CSSModules(Styles)
export default class FooterPartner extends Component {
  constructor(props){
    super(props)
  }
  render() {
    return (
      <div styleName='logo-second-wrap'>
        <Link
          to={config.links.aysinvest}
          title='Invest Your Values'>
          <div styleName='footer-headline'>
            Invest Your Values
          </div>
        </Link>
        <div styleName='footer-tagline'>
          Sustainable investment tools for<br/>climate change, gender equality, more
        </div>
        <Link
          to={config.links.aysinvest}
          title='Invest Your Values'>
          <div styleName='footer-link'>
            Learn more<LinkIcon />
          </div>
        </Link>
      </div>
    )
  }
}
